import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

const IndexPage = () => (
  <Layout>
    <SEO title="Home" />
    <h1>Always a new thing. </h1>
    <p>Takeo Tamura（　田村　岳夫　）</p>

    <p>
      Engineer, Designer, Full-stack Developer.
      ❤️ 🧘‍️ ❤️ Fashion ❤️ TOKYO ❤️ Serverless ❤️ UX ❤️ 🍶 & 🍣
    </p>
  </Layout>
)

export default IndexPage
